import FullWidthSection from '@/components/full-width-section';
import ImageOptimizer from '@/components/image-optimizer';

const AwardsSection = () => {
  return (
    <FullWidthSection className="bg-black">
      {/** 웹 */}
      <div
        className="desktop:flex mx-auto hidden h-25 items-center justify-center"
        style={{
          backgroundImage: 'url(/images/main/award_bg.webp)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <ImageOptimizer
          src="/images/main/awards.svg"
          alt={'대한민국히트브랜드 대상'}
          width={859}
          height={50}
          className="shrink-0 object-cover"
        />
      </div>

      {/** 모바일 */}
      <div
        className="desktop:hidden relative h-24 overflow-hidden py-5"
        style={{
          backgroundImage: 'url(/images/main/award_bg.webp)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div
          className="animate-slide-loop flex h-full"
          style={{ width: 'calc(963.3px * 2)' }}
        >
          {[1, 2].map((index) => (
            <ImageOptimizer
              key={index}
              src="/images/main/awards.svg"
              alt={'대한민국히트브랜드 대상'}
              width={963.3}
              height={96}
              className="h-full w-[963.3px] shrink-0 object-cover"
            />
          ))}
        </div>
      </div>
    </FullWidthSection>
  );
};

export default AwardsSection;
